import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../../../services/api.service';

@Component({
  selector: 'app-profile-password',
  templateUrl: './profile-password.component.html',
  styleUrls: ['./profile-password.component.scss']
})
export class ProfilePasswordComponent {
  oldPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  errorMessage: string = null;

  constructor(private apiService: ApiService, private router: Router) {
  }

  submit() {
    this.sniff('CHANGE_PASSWORD', '');
    this.errorMessage = null;
    if (this.newPassword.length == 0)
      this.errorMessage = "โปรดกรอกรหัสผ่าน";
    else if (this.confirmPassword !== this.newPassword)
      this.errorMessage = "รหัสผ่านไม่ตรงกัน";
    else {
      this.apiService.updatePassword({
        old_password: this.oldPassword,
        new_password: this.newPassword
      }).subscribe(
        () => this.router.navigate(['']),
        error => {
          let message = this.apiService.getErrorMessage(error);
          this.errorMessage = message
        }
      );
    }
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'MANAGE_USER',
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.ts